import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FolderOpen, FileText, Users, Building2, Crown, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";

const Dashboard = () => {
  const { signOut, user } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        <div className="max-w-5xl mx-auto px-4 py-4 flex items-center justify-between">
          <h1 className="text-lg font-bold text-foreground">Admin Dashboard</h1>
          <div className="flex items-center gap-3">
            <span className="text-sm text-muted-foreground hidden sm:inline">{user?.email}</span>
            <Button variant="ghost" size="sm" onClick={signOut}>
              <LogOut className="w-4 h-4 mr-1" /> Logout
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 py-12">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="grid grid-cols-1 sm:grid-cols-2 gap-6"
        >
          <Link to="/admin/projects" className="group">
            <div className="bg-card border border-border rounded-lg p-8 hover:border-primary transition-colors">
              <FolderOpen className="w-10 h-10 text-primary mb-4" />
              <h2 className="text-xl font-bold text-foreground mb-2">Manage Projects</h2>
              <p className="text-sm text-muted-foreground">Add, edit, and delete architectural projects with images and videos.</p>
            </div>
          </Link>
          <Link to="/admin/blog" className="group">
            <div className="bg-card border border-border rounded-lg p-8 hover:border-primary transition-colors">
              <FileText className="w-10 h-10 text-primary mb-4" />
              <h2 className="text-xl font-bold text-foreground mb-2">Manage Blog</h2>
              <p className="text-sm text-muted-foreground">Create and manage blog posts, awards, and client testimonials.</p>
            </div>
          </Link>
          <Link to="/admin/team" className="group">
            <div className="bg-card border border-border rounded-lg p-8 hover:border-primary transition-colors">
              <Users className="w-10 h-10 text-primary mb-4" />
              <h2 className="text-xl font-bold text-foreground mb-2">Manage Team</h2>
              <p className="text-sm text-muted-foreground">Add, edit, and reorder team members shown on the About page.</p>
            </div>
          </Link>
          <Link to="/admin/clients" className="group">
            <div className="bg-card border border-border rounded-lg p-8 hover:border-primary transition-colors">
              <Building2 className="w-10 h-10 text-primary mb-4" />
              <h2 className="text-xl font-bold text-foreground mb-2">Manage Clients</h2>
              <p className="text-sm text-muted-foreground">Update the Our Valued Clients showcase logos and details.</p>
            </div>
          </Link>
          <Link to="/admin/leaders" className="group">
            <div className="bg-card border border-border rounded-lg p-8 hover:border-primary transition-colors">
              <Crown className="w-10 h-10 text-primary mb-4" />
              <h2 className="text-xl font-bold text-foreground mb-2">Manage Leaders</h2>
              <p className="text-sm text-muted-foreground">Edit leadership profile pages with full bio, education, and content.</p>
            </div>
          </Link>
        </motion.div>
      </main>
    </div>
  );
};

export default Dashboard;
